import { TAB_IDS, type TabId } from "@empire/shared";
import { useUiStore } from "../../store/ui.js";
import en from "@empire/shared/i18n/en.json";
import { GameIcon } from "./GameIcon.js";

const LABELS: Record<TabId, string> = {
  village: en["tab.village"],
  map: en["tab.map"],
  trials: en["tab.trials"],
  reports: en["tab.reports"],
};

export function TabBar(): JSX.Element {
  const tab = useUiStore((s) => s.tab);
  const setTab = useUiStore((s) => s.setTab);

  return (
    <nav
      className="empire-tabs grid grid-cols-4 border-t border-panel-edge bg-bg-raised"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {TAB_IDS.map((id) => {
        const active = id === tab;
        return (
          <button
            key={id}
            type="button"
            onClick={() => setTab(id)}
            aria-current={active ? "page" : undefined}
            className={`flex h-14 flex-col items-center justify-center gap-1 text-[11px] font-semibold tracking-wide transition-colors ${
              active ? "text-gold" : "text-ink-dim hover:text-ink"
            }`}
          >
            <GameIcon name={id} />
            {LABELS[id]}
          </button>
        );
      })}
    </nav>
  );
}
